import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { RadioGroup as MuiRadioGroup, FormControl, FormLabel } from '@material-ui/core';

var RadioGroup = function RadioGroup(_ref) {
  var a11yLabel = _ref.a11yLabel,
      children = _ref.children,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      dsOnChange = _ref.dsOnChange,
      e2e = _ref.e2e,
      error = _ref.error,
      label = _ref.label,
      name = _ref.name,
      required = _ref.required,
      row = _ref.row,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value;
  return /*#__PURE__*/React.createElement(FormControl, _extends({
    disabled: disabled,
    error: error,
    required: required
  }, e2e && {
    'data-e2e': e2e
  }), !!label && /*#__PURE__*/React.createElement(FormLabel, _extends({
    disabled: disabled
  }, e2e && {
    'data-e2e': "".concat(e2e, "-label")
  }), label), /*#__PURE__*/React.createElement(MuiRadioGroup, _extends({
    "aria-label": a11yLabel,
    defaultValue: defaultValue,
    name: name,
    onChange: dsOnChange,
    row: row,
    value: value
  }, e2e && {
    'data-e2e': "".concat(e2e, "-radiogroup")
  }), children));
};

export default RadioGroup;

try {
  RadioGroup.__docgenInfo = {
    description: '',
    displayName: 'RadioGroup',
    methods: [],
    props: {
      a11yLabel: {
        defaultValue: null,
        description: 'ARIA label. Use if component if not accompanied by a visible label.',
        name: 'a11yLabel',
        required: false,
        type: {
          name: 'string'
        }
      },
      disabled: {
        defaultValue: null,
        description: '',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: false,
        type: {
          name: '(event: ChangeEvent<HTMLInputElement>, value: string) => void'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      error: {
        defaultValue: null,
        description: '',
        name: 'error',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: true,
        type: {
          name: 'string'
        }
      },
      required: {
        defaultValue: null,
        description: '',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      defaultValue: {
        defaultValue: null,
        description: 'The default `input` element value. Use when the component is not controlled.',
        name: 'defaultValue',
        required: false,
        type: {
          name: 'string | number | readonly string[]'
        }
      },
      name: {
        defaultValue: null,
        description: 'The name used to reference the value of the control.\n' + "If you don't provide this prop, it falls back to a randomly generated name.",
        name: 'name',
        required: false,
        type: {
          name: 'string'
        }
      },
      value: {
        defaultValue: {
          value: null
        },
        description: 'Value of the selected radio button. The DOM API casts this to a string.',
        name: 'value',
        required: false,
        type: {
          name: 'any'
        }
      },
      row: {
        defaultValue: null,
        description: 'Display group of elements in a compact row.',
        name: 'row',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map